import styled from 'vue-styled-components'
const WrapperToolProps = {
  marginHeight: 0,
  positionTool: Object,
  borderObject:Object,
  shadowObject:Object,
  backgroundObject:Object
}
const WidgetTool = styled('div', WrapperToolProps)`
  pointer-events: all;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  justify-content: center;
  right: 0;
  font-weight: 500;
  transition: all 0.1s ease;
  line-height: 1;
  font-size: 20px;
  .badge {
    padding: 4px 16px;
    height: 32px;
    gap: 10px;
    position: absolute;
    border: ${({borderObject}) => borderObject && borderObject.border ? borderObject.border : '1px solid #dee3e6 !important'};
    box-shadow: ${({shadowObject}) => shadowObject && shadowObject.shadow ? shadowObject.shadow : '0px 8px 16px 0px #00000026'};
    background: ${({backgroundObject}) => backgroundObject && backgroundObject.background ? backgroundObject.background : '#ffffff !important'};
    right: ${({positionTool}) => positionTool.right};
    left: ${({positionTool}) => positionTool.left};
    &.top {
      bottom: ${({marginHeight}) => marginHeight < 90 && marginHeight > 10 ? marginHeight - (marginHeight*0.3) + 'px' : '10px'};
    }
    &.bottom {
      top: ${({marginHeight}) => marginHeight < 90 && marginHeight > 10 ? marginHeight - (marginHeight*0.3) + 'px' : '10px'};
      &.header-widget {
        top: 24px;
      }
    }
    .btn-tool {
      .icon {
        width: 16px;
        height: 16px;
        svg {
          width: 16px;
        }
      }
      svg {
        width: 16px;
      }
    }
    .btn-tool.active {
      svg, .fs-db-20 {
        color: #12A9FF
      }
    }
    .btn-tool:hover {
      svg, .fs-db-20 {
        color: #24BEE2
      }
    }
  }
`;

const WrapperProps = {
  position: {},
  parentWidget: false,
  isActiveWidget: false,
}
const Wrapper = styled('div', WrapperProps)`
pointer-events: none;
position: absolute;
width: ${({ position }) => position.width};
height: ${({ position }) => position.height};
top: ${({ position }) => position.top};
left: ${({ position }) => position.left};
z-index: 7;
.label-name-frame{
  z-index: 1;
  bottom: 100%;
  white-space: nowrap;
}
&::after {
  position: absolute;
  content: '';
  top: 0;
  width: 100%;
  height: 100%;
  border: ${({ parentWidget, isActiveWidget }) => parentWidget || isActiveWidget ? '1px' : '4px'}  solid ${({ parentWidget, isActiveWidget }) => isActiveWidget ? '#A9A9A9' : (parentWidget ? '#0B77B5' : '#12A9FF')};
  z-index: 4;
}
&.top {
  .lbl-name, .widget-tool {
    z-index: 1;
    bottom: 100%;
    white-space: nowrap;
  }
}
&.bottom {
  .lbl-name {
    z-index: 1;
    top: 100%;
    white-space: nowrap;
  }
  .widget-tool {
    z-index: 1;
    top: 100%;
    white-space: nowrap;
  }
}

&.widget-active-frame-blue-dark {
  &::after {
    border: 1px solid #0B77B5;
  }
  .label-name-frame {
    background-color: #0B77B5;
    border: 1px solid #0B77B5;
    color: #FFFFFF;
  }
}
`
export {
  WidgetTool,
  Wrapper
}